<div class="content">
    <mat-tab-group>
        <mat-tab *ngFor="let category of categories" [label]="category.name">
            <app-works-list [works]="category.works"></app-works-list>
        </mat-tab>
    </mat-tab-group>
</div>